import { schema as schemas } from 'normalizr'
import { CallApi, cachePolicies } from '@signavio/kraken'

import { schema as dictionaryConnectorSchema } from './dictionaryConnector'

export { collection } from './dictionaryConnector'
export const schema = new schemas.Array(dictionaryConnectorSchema)

export const fetch = (callApi: CallApi, apiBase: string) => () =>
  callApi(`${apiBase}/dictionary/connectors`, schema)

export const cachePolicy = cachePolicies.queryFromCache
